export default __webpack_public_path__ + "static/media/gas-station.43652c57.svg";